/** 三大模块功能触发说明（与后端业务逻辑一致） */
export const FEATURE_GUIDES = [
  {
    key: 'checkin',
    icon: '🔥',
    title: '每日打卡',
    trigger: '今日学习 ≥10 个单词，或累计学习时长 ≥5 分钟',
    how: '达标后首页/打卡页点击「立即打卡」；达标后学习、练习时系统也会尝试自动打卡',
    reward: '每次打卡 +10 积分，连续打卡可解锁成就与额外奖励'
  },
  {
    key: 'review',
    icon: '🔄',
    title: '智能复习',
    trigger: '在单元页学习过的单词，到达艾宾浩斯复习时间（next_review_at）',
    how: '首页「立即复习」或练习中心进入；到期单词会出现在待复习列表',
    reward: '每复习 1 词 +1 积分（每日上限 30）'
  },
  {
    key: 'error',
    icon: '📕',
    title: '错题本',
    trigger: '单词练习、智能复习等答错时自动加入',
    how: '我的 → 错题本，或智能复习页「错题本」模式集中复习',
    reward: '反复练对后可标记掌握，移出错题本'
  },
  {
    key: 'star',
    icon: '⭐',
    title: '重点单词',
    trigger: '复习过程中点击「标为重点」，或多次复习仍不熟练的单词',
    how: '智能复习页 → 重点单词模式；复习卡片底部可标记/取消重点',
    reward: '重点词会优先出现在重点复习列表（status=需重点复习）'
  },
  {
    key: 'mp',
    icon: '🏛',
    title: '记忆宫殿',
    trigger: '首页「四大功能」或「我的」→ 记忆宫殿',
    how: '选模板/自定义建宫殿 → 锚点绑定已学词（自动带入拆分+联想+配图）→ 编写场景联想与故事线 → 漫游/故事线/听写复习',
    reward: '复习 +10 积分；创建宫殿解锁建造师；掌握达标解锁记忆大师'
  },
  {
    key: 'cp',
    icon: '🧩',
    title: '语境拼图',
    trigger: '首页/我的 → 语境拼图；每日推荐场景',
    how: '看场景与单词记忆法 → 听读拼对话空缺 → 提交由系统判分 → 生成生存卡收藏',
    reward: '首次完成 +20 积分；累计多关解锁拼图达人；免费用户每日次数有限'
  },
  {
    key: 'et',
    icon: '🌳',
    title: '家族词源树',
    trigger: '我的 → 词源树；可自建或邀请码加入',
    how: '选词根（含拆分记忆故事）种树 → 邀请家人 → 浇水长叶 → 看成长日志与留言',
    reward: '浇水 +5 积分；园丁/森林守护者成就；免费用户树与人数有上限'
  },
  {
    key: 'sl',
    icon: '📖',
    title: '故事接龙擂台',
    trigger: '首页/我的 → 故事擂台',
    how: '选赛事看指定词记忆法 → 组队轮流造句（须含指定词）→ 投票评论 → 收藏金句看排行',
    reward: '有效接龙积分；创建队伍需开通词书；冠军解锁故事冠军'
  }
]

export default FEATURE_GUIDES



// WEBPACK FOOTER //
// ./src/utils/featureGuide.js